// Format a number with a fixed number of decimals and thousands separators
export default function formatCurrency(number: number, precision: number = 0): string {
  switch (typeof number) {
    case "number":
      if (isNaN(number)) return "---";
      return number.toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: precision,
        maximumFractionDigits: precision,
      });

    default:
      return "---";
  }
}

export const costWithCommas = (value: number) => value && `$${numberWithCommas(value)}`;

export const numberWithCommas = (value: number) => value && value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

export const notCoveredOrFormatCurrency = (value) => {
  if (value == "Not Covered") {
    return value;
  }
  return formatCurrency(value);
};
